import _ from 'lodash'
import StoreHelper from '../store/helper'

class RouterHelper {
  static extractParentRoutePath ({ path }) {
    return _(path).split('/').dropRight().join('/').trimEnd('/')
  }

  static createSubRoutePath (route, name) {
    const path = this.extractPath(route)

    return _.trimEnd(path, '/').concat(`/${name}`)
  }

  static createMenuViewRoute (name, path, view) {
    return {
      // @todo there is a router.push with 'name' somewhere which causes interference if there are bubble-items with the same name
      name: StoreHelper.getInitialRouteName() + '-' + _(path).trim('/').split('/').join('-'),
      path,
      components: { bMenuRouterView: view },
      meta: { isBubbleMenuRoute: true }
    }
  }

  static attachRoute (router, targetRouteName, routeToAttach) {
    const routes = this.extractRoutes(router)
    const targetRoute = this.findRouteByName(routes, { name: targetRouteName })

    if (_.isArray(targetRoute.children)) {
      targetRoute.children.push(routeToAttach)
    } else {
      targetRoute.children = [routeToAttach]
    }

    router.addRoutes(routes)
  }

  static extractRoutes (router) {
    return _.get(router, 'options.routes', null)
  }

  static routeExists (router, route) {
    if (_.has(route, 'path')) {
      return RouterHelper.findRouteByPath(RouterHelper.extractRoutes(router), route)
    }

    return RouterHelper.findRouteByName(RouterHelper.extractRoutes(router), route)
  }

  static extractPath (route) {
    return _.get(route, 'path')
  }

  static extractCurrentRoute (router) {
    return _.get(router, 'currentRoute')
  }

  static findRouteByName (routes, { name }) {
    for (const route of routes) {
      if (_.isEqual(route.name, name)) {
        return route
      }

      const targetRoute = this.findRouteByName(_.get(route, 'children', []), { name })
      if (targetRoute) {
        return targetRoute
      }
    }
  }

  static findRouteByPath (routes, { path }) {
    for (const route of routes) {
      if (_.isEqual(route.path, path)) {
        return route
      }

      const targetRoute = this.findRouteByPath(_.get(route, 'children', []), { path })
      if (targetRoute) {
        return targetRoute
      }
    }
  }

  static goTo (router, route) {
    router.push(route)
  }
}

export default RouterHelper
